import { SideNavAction, TOGGLE_SIDENAV } from '../_types/sideNav';

export const toggleSideNavigation = (open: boolean): SideNavAction => {
    return {
        type: TOGGLE_SIDENAV,
        payload: open,
    };
};
